<div *ngIf="loading" class="loading">
    <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
</div>
<div class="dismissal-reports-container">
    <div class="dismissal-reports-container-header" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
        <svg (click)="back()" xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 6.576 11.257" [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}">
            <g id="next_1_" data-name="next (1)" transform="translate(6.022 10.703) rotate(180)">
                <g id="Group_5442" data-name="Group 5442" transform="translate(0 0)">
                    <path id="Path_5603" data-name="Path 5603"
                        d="M107.651,5.354l-4.687,4.687a.391.391,0,0,1-.552-.552l4.411-4.411L102.411.667a.391.391,0,0,1,.552-.552L107.651,4.8A.391.391,0,0,1,107.651,5.354Z"
                        transform="translate(-102.297 0)" fill="#707070" stroke="#707070" stroke-width="1" />
                </g>
            </g>
        </svg>
        <span class="dismissal-reports-container-header-label">{{'dismissal-flowlog.process-reports' | translate}}</span>
    </div>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" id="home-tab" data-toggle="tab" (click)="tabClicked('home-tab')" href="#home" role="tab" aria-controls="home"
                aria-selected="true">{{'dismissal-flowlog.school-flowlog' | translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" (click)="tabClicked('profile-tab')" href="#profile" role="tab" aria-controls="profile"
                aria-selected="false">{{'dismissal-flowlog.student-flowlog' | translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" id="contact-tab" data-toggle="tab" (click)="tabClicked('contact-tab')" href="#contact" role="tab" aria-controls="contact"
                aria-selected="false">{{'dismissal-flowlog.student-avg-dismissal' | translate}}</a>
        </li>
    </ul>
    <div class="tab-content" id="report-card">
        <app-reports-control-bar [controlType]="getControlType()" (exportExcel)="exportToExcelFile()" (generateExcel)="generateExcelFile()"></app-reports-control-bar>
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <app-school-dimissal-flow-log (stopLoading)="stopLoading()" [showHeader]="false" [activeTab]="activeTab">
            </app-school-dimissal-flow-log>
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)">
            </app-table-view>
        </div>
        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)">
            </app-table-view>
        </div>
    </div>
</div>
<app-view-student></app-view-student>
<app-error-msg></app-error-msg>